import { createTheme } from "@mui/material"
import { colors, fontSize, size } from "./theme"

const theme = createTheme({
  palette: {
    primary: {
      main: colors.statusColors.right_now('primary'),
    },
    error: {
      main: colors.error(500),
    },
    success: {
      main: colors.success(500),
    },
  },
  typography: {
    fontFamily: [
      'system-ui', "'Segoe UI'", 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
      'Fira Sans', "'Droid Sans'", "'Helvetica Neue'", 'sans-serif'
    ].join(','),
    color: 'white',
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 0,
          height: size(4.5)
        },
        indicator: {
          height: '4px',
          borderRadius: '100px',
          // backgroundColor: '#19B1D2',
          backgroundColor: '#6A23FF',
          // backgroundColor: '#3750bf',
        },
        flexContainer: {
          justifyContent: 'space-evenly'
        }
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          letterSpacing: '0.35px',
          height: size(4.5),
          minHeight: 0,
          paddingBottom: size(2),
        },
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          minHeight: 0,
          height: size(6),
        },
      }
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          // minHeight: '48px',
          // height: '52px',
        },
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: 0,
          height: size(6),
        },
      }
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        label: {
          lineHeight: '0.75rem !important',
          fontSize: '0.75rem !important',
        },
      }
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: '#333333',
          color: 'white',
          borderRadius: 4,
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#333333',
          color: 'white',
          borderRadius: 4,
        }
      }
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: 'lightgrey',
        },
        bar: {
          backgroundColor: '#6A23FF',
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        action: {
          padding: 0,
        }
      }
    },
    MuiModal: {
      styleOverrides: {
        root: {
          overflowAnchor: 'none',
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          zIndex: 1300,
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          minHeight: `0 !important`,
        },
        content: {
          margin: '12px 0!important',
        }
      }
    },
  }
})
// MuiList-root MuiList-padding MuiMenu-list css-6hp17o-MuiList-root-MuiMenu-list
export default theme
